import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CategoryMallService } from 'src/app/admin/services/category-mall/category-mall.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-list-mall-category',
    templateUrl: './list-mall-category.component.html',
    styleUrls: ['./list-mall-category.component.scss'],
    standalone: false
})
export class ListMallCategoryComponent implements OnInit {

  constructor(
    private categoryMallService: CategoryMallService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private toast: ToastrService
  ) { }
  title = 'angular-datatables';

  dataList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getCategoryList()
  }

  /* ***********
  list Category
  *********** */

  getCategoryList() {
    this.spinner.show()
    this.categoryMallService.listMallCategory({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.dataList = res.data;
        this.temp = this.dataList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d: any) {
      return d.categoryname.toLowerCase().indexOf(val) !== -1 ||
        d.categoryId.toString().indexOf(val) !== -1 ||
        d.categorydescription.toString().indexOf(val) !== -1 ||
        d.category_slug.toLowerCase().indexOf(val) !== -1 || !val
    });

    // update the rows
    this.dataList = temp;
    // Whenever the filter changes, always go back to the first page
    this.myFilterTable.offset = 0;
  }

  /** Enable/disable category*/
  public toggle($event: any, data: any) {
    this.categoryMallService.updateMallCategory({ '_id': data._id, 'status': !data.status, updatedId: this.userdata.getId(), updatedBy: this.userdata.getName() }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.toast.success(res.message, 'Success')
        this.getCategoryList()
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
        this.toast.error(err.error.message, 'Error')
      }
    );
  }

}
